import { HttpClient } from "@angular/common/http";
import { SCAMP_API, SCAMP_API_RPT } from "src/environments/environment";
import { AccountService } from "./account.service";
import { APP_SETTINGS } from "src/environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class OSService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getSpvsParaOS(empreiteiraId, encarregadoResponsavelId, tipoProgramacao) {
        return this.http.get(`${SCAMP_API.accountApiV1}/spvs-para-os/${empreiteiraId}/${encarregadoResponsavelId}/${tipoProgramacao}/${APP_SETTINGS.tipoInstalacao}`, { headers: this.account.composeHeaders() });
    }
    getOSsParaFechar(parameters) {
        parameters.tipoInstalacao = APP_SETTINGS.tipoInstalacao;
        console.log('parameters: ', parameters);
        return this.http.post(`${SCAMP_API.accountApiV1}/oss-para-fechar`, parameters, { headers: this.account.composeHeaders() });
    }
    getOSsParaFecharQtd(parameters) {
        parameters.tipoInstalacao = APP_SETTINGS.tipoInstalacao;
        return this.http.post(`${SCAMP_API.accountApiV1}/oss-para-fechar-qtd`, parameters, { headers: this.account.composeHeaders() });
    }
    getOSsPorPTIdOuSpvAprovadoId(Ids) {
        return this.http.post(`${SCAMP_API.accountApiV1}/oss/os-por-ptid-spvaprovadoid`, { Ids: Ids }, { headers: this.account.composeHeaders() });
    }
    gerarOSs(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/gerar-oss`, data, {
            headers: this.account.composeHeaders(),
        });
    }
    editarOS(osEditada, osCompleta) {
        osEditada.colaboradores = osCompleta.spvCompleto.colaboradores.map((t) => {
            return {
                oSId: osCompleta.osId,
                spvAprovadoId: osCompleta.spvCompleto.spvAprovadoId,
                ptId: osCompleta.spvCompleto.ptId,
                funcionarioId: t.id,
                dataHoraInicio: t.dataHoraInicio,
                dataHoraFim: t.dataHoraFim,
                categoriaId: t.categoriaId,
                valor: t.valor,
            };
        });
        osEditada.irregularidades = osCompleta.irregularidades;
        osEditada.uploadPhotos = osCompleta.uploadPhotos;
        osEditada.materiaisUsado = osCompleta.materiaisUsado;
        return this.http.post(`${SCAMP_API.accountApiV1}/oss/editar`, osEditada, {
            headers: this.account.composeHeaders(),
        });
    }
    consultarOSs(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/consultar-oss`, data, {
            headers: this.account.composeHeaders(),
        });
    }
    getOSparaAvaliar() {
        return this.http.get(`${SCAMP_API.accountApiV1}/oss-para-validar`, {
            headers: this.account.composeHeaders(),
        });
    }
    getOSCompleta(osid, spvId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/os-completa/${osid}/${Number(spvId)}`);
    }
    cancelarOS(osid) {
        return this.http.post(`${SCAMP_API.accountApiV1}/cancelar-os/${osid}`, null);
    }
    qualificarOS(osid) {
        return this.http.post(`${SCAMP_API.accountApiV1}/qualificar-os/${osid}`, null);
    }
    setStatusOS(osid, status) {
        return this.http.post(`${SCAMP_API.accountApiV1}/set-status-os/${osid}/${status}`, null);
    }
    setStatusOSAberta(osid) {
        return this.http.post(`${SCAMP_API.accountApiV1}/set-status-os-aberta/${osid}`, null);
    }
    // Servidor de Relatórios
    imprimirOS(osid, tipoOSFilha, imprimirEvidenciaDeFotos) {
        return this.http.get(`${SCAMP_API_RPT.accountApiV1}/rpt-os/${osid}/${tipoOSFilha}/${imprimirEvidenciaDeFotos}`);
    }
    imprimirOSMerge(osTipos) {
        return this.http.post(`${SCAMP_API_RPT.accountApiV1}/rpt-os-merge`, osTipos);
    }
    GetOSsStatusExecutada() {
        return this.http.get(`${SCAMP_API.accountApiV1}/lista-oss-executadas/`, { headers: this.account.composeHeaders() });
    }
    GetTiposOSs() {
        return this.http.get(`${SCAMP_API.accountApiV1}/oss/tipos-oss`, {
            headers: this.account.composeHeaders(),
        });
    }
    exportarToExcel(parametros) {
        return this.http.post(`${SCAMP_API.accountApiV1}/oss/emitidas/excel`, parametros, { headers: this.account.composeHeaders() });
    }
    removerUploadPhoto(uploadPhotoId) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/upload-photo/remove/${Number(uploadPhotoId)}`, { headers: this.account.composeHeaders() });
    }
    imprimirOSMaterialUtilizado(osids) {
        return this.http.post(`${SCAMP_API_RPT.accountApiV1}/rpt-osmaterialutilizado`, { OSIds: osids });
    }
    getMaterialUtilizadoExcel(osids) {
        return this.http.post(`${SCAMP_API.accountApiV1}/oss/material-utilizado/excel`, { OSIds: osids }, { headers: this.account.composeHeaders() });
    }
    imprimirOSFuncionarioAtuante(osids) {
        return this.http.post(`${SCAMP_API_RPT.accountApiV1}/rpt-osfuncionariosatuantes`, { OSIds: osids });
    }
    imprimirOs(osids) {
        return this.http.post(`${SCAMP_API_RPT.accountApiV1}/rpt-os`, {
            OSIds: osids,
        });
    }
}
OSService.ngInjectableDef = i0.defineInjectable({ factory: function OSService_Factory() { return new OSService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: OSService, providedIn: "root" });
